import { orderBy } from "natural-orderby";

export const caseInsensitiveSortBy = (data: any[], by?: string) => {
  return orderBy(data, [(v) => (by ? v[by] : v)], ["asc"]);
};
